import { createContext, useContext } from 'react'

export const BlueprintsContext = createContext()

export default function useBlueprintsContext() {
  return useContext(BlueprintsContext)
}
